/// <amd-module name="SuiteCommerce.Blog.PostCard.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostCard.View", ["require", "exports", "Backbone", "sc_blog_post_card.tpl", "sc_blog_post_card_dummy.tpl", "SuiteCommerce.Blog.Common", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, Backbone_1, postCardTemplate, postCardTemplateDummy, Common_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostCardView = exports.PostCardLayout = void 0;
    var PostCardLayout;
    (function (PostCardLayout) {
        PostCardLayout["horizontal"] = "horizontal";
        PostCardLayout["vertical"] = "vertical";
    })(PostCardLayout = exports.PostCardLayout || (exports.PostCardLayout = {}));
    var PostCardView = /** @class */ (function (_super) {
        __extends(PostCardView, _super);
        function PostCardView(options) {
            var _this = _super.call(this, options) || this;
            _this.layout = options.layout;
            _this.highlightInCard = Common_1.sanitizeString(options.highlightInCard);
            _this.template = _this.model.isDummy
                ? postCardTemplateDummy
                : postCardTemplate;
            _this.model.on('change:categoryName', function () {
                _this.$el.replaceWith(_this.render().$el.html());
            });
            _this.events = {
                'click [data-action="navigate-to-blog"]': 'navigateToBlogPost',
            };
            return _this;
        }
        PostCardView.prototype.navigateToBlogPost = function (event) {
            if (event.target.tagName === 'A') {
                return true;
            }
            Backbone_1.history.navigate(this.model.url, true);
        };
        PostCardView.prototype.getContext = function () {
            return {
                category: this.model.categoryName,
                excerpt: this.highlightText(this.model.excerpt),
                header: this.highlightText(this.model.header),
                readMoreLabel: Configuration_1.Configuration.readMoreLabel,
                thumbnailAlt: this.model.thumbnailImageAlt,
                thumbnailUrl: this.model.thumbnailImageURL,
                thumbnailResizeId: this.model.thumbnailImageResizeName,
                url: this.model.url,
                layout: this.layout,
                showThumbnailContainer: !this.model.isDummy,
                showThumbnail: !!this.model.thumbnailImageURL,
                categoryURL: this.model.categoryURL,
            };
        };
        PostCardView.prototype.highlightText = function (textToHighlight) {
            if (this.highlightInCard && textToHighlight) {
                return textToHighlight.replace(new RegExp(this.highlightInCard, 'ig'), function (replacedText) {
                    return "<mark>" + replacedText + "</mark>";
                });
            }
            return textToHighlight;
        };
        return PostCardView;
    }(Backbone_1.View));
    exports.PostCardView = PostCardView;
});
